
import Vue from 'vue'
import Component from 'vue-class-component'
import { required } from 'vuelidate/lib/validators'
import { Validations } from 'vuelidate-property-decorators'
import EventBus from '@/eventBus'

@Component
export default class ManageNptSettings extends Vue {
    @Validations()
    validations = {
        nptSetting: {
            nptCategory: { required },
        }
    }
    activeScreen: string = 'main'
    loadingMessage: string = 'Please wait while we create new NPT Setting'
    loadingTitle: string = 'Saving...'
    additionalSuccessMessage: string = ''
    successMessage: string = 'New NPT Setting Created Successfully'
    links: Array<object> = [
        {
            text: 'NPT Settings',
            to: '/npt-settings'
        },
        {
            text: 'Manage NPT Settings',
            active: true
        }
    ]
    error: any = {
        generalMessage: '',
        errors: []
    }
    nptSetting: any = {
        nptCategory: '',
    }
    nptSettingRootCauseList: string[] = []
    activeItem: any = null
    formErrors: string[] = []


    // METHODS
    checkErrors() {
        this.formErrors = []

        if (this.nptSetting.nptCategory.length < 1) {
            this.formErrors.push('Root Cause is required')
        }
        if (this.nptSettingRootCauseList.length < 1) {
            this.formErrors.push('At least one Associated Cause is required')
        }
    }

    newSetting() {
        this.nptSetting.nptCategory = '';
        this.$v.$reset()
    }

    persistData() {
        this.activeScreen = 'loading';
        EventBus.$emit('activeScreen', this.activeScreen)
        if (this.activeItem == null)
            this.saveNew();
        else
            this.update();
    }

    update() {
        this.activeScreen = 'loading'
        EventBus.$emit('activeScreen', this.activeScreen)
        this.loadingMessage = 'Please wait while we update this NPT Setting'
        this.loadingTitle = 'Updating...'
        var payload = this.createPayload()
        this.$store.dispatch('settingsModule/updateNptSettings', {id: this.activeItem.id, nptSetting: payload})
            .then((res: any) => {
                this.activeScreen = 'successNoGotIt'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.additionalSuccessMessage = ''
                this.successMessage = 'NPT Setting Updated Successfully'
            }
            ).catch((err: any) => {
                this.activeScreen = 'error'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.error.generalMessage = err.response.data.data
            })
    }

    createPayload() {
        return {
            nptCategory: this.nptSetting.nptCategory,
            rootCauses: this.nptSettingRootCauseList
        }
    }

    saveNew() {
        var payload = this.createPayload()
        
        this.$store.dispatch('settingsModule/createNptSetting', payload)
            .then((res: any) => {
                this.activeScreen = 'successRemain'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.additionalSuccessMessage = 'You can now use the new NPT Setting'
                this.successMessage = 'Successfully Created ' + payload.nptCategory
                this.newSetting()
            }
            ).catch((err: any) => {
                this.activeScreen = 'error'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.error.generalMessage = err.response.data.data
            })
    }

    get isButtonDisabled(): boolean {
        if (this.formErrors.length > 0) {
            return true
        } else {
            return false
        }
    }

    get fetchNptSettings() {
        return this.$store.dispatch('settingsModule/getNptSettings')
    }

    get currentNptSettings() {
        return this.$store.getters['settingsModule/getNptSettings']
    }

    // CREATED
    created() {
        this.fetchNptSettings.then(() => {
            if (this.$route.query.id) {
                this.activeItem = this.currentNptSettings.find((i: any) => i.id == this.$route.query.id)

                this.nptSetting.id = this.activeItem.id;
                this.nptSetting.nptCategory = this.activeItem.nptCategory,
                this.nptSettingRootCauseList = this.activeItem.rootCauses;
            } else {
                this.checkErrors()
            }
        });
        this.checkErrors()
    }
}

